import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const Home = () => {
    const { currentUser } = useAuth();
    const location = useLocation();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // 'success' | 'error' | 'info' | 'warning'

    useEffect(() => {
        if (location.state?.message) {
            setSnackbarMessage(location.state.message);
            setSnackbarSeverity(location.state.type || 'success');
            setOpenSnackbar(true);
        }
    }, [location.state]);

    return (
        <div className='flex justify-center items-center min-h-screen bg-gray-100 relative'>
         
            <div className='bg-white shadow-lg rounded-2xl p-8 max-w-md text-center relative z-10'>
                <h1 className='text-3xl font-bold text-gray-800'>Welcome!</h1>
                <p className='text-lg text-gray-600 mt-4'>
                    Hello, <span className='font-semibold text-gray-900'>{currentUser.displayName || currentUser.email}</span>
                </p>
                <p className='text-gray-500 mt-2'>You are now logged in.</p>
            </div>
            
            {/* Snackbar */}
            <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)}>
                <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Home;
